module.exports = __webpack_public_path__ + "static/media/smarttinvest-circle-logo.177b39d0.svg";